module.exports = __webpack_public_path__ + "static/media/ballokke.f2733376.svg";